module.exports = __webpack_public_path__ + "img/tema-3-13.839359b4.png";